import React from "react";
import { Box, Typography } from "@mui/material";
import { CompareArrows as CompareIcon } from "@mui/icons-material";
import { colors } from "../../theme";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";

const formatToday = () =>
  new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

const HomeHero = () => (
  <Box
    sx={{
      mb: 3,
      p: { xs: 2, sm: 3 },
      borderRadius: 2,
      border: `1px solid ${colors.border}`,
      background: `linear-gradient(135deg, ${colors.paper} 0%, ${brandRgba(BRAND_COLORS.cyan, 0.08)} 100%)`,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
      <Box>
        <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1.2 }}>
          {formatToday()}
        </Typography>
        <Typography variant="h4" component="h1" fontWeight={700} sx={{ mt: 0.5, mb: 1 }}>
          Settle the debate
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 560 }}>
          Compare legends, learn the numbers, and argue about the greatest players
          ever — backed by real MLB stats.
        </Typography>
      </Box>
      <CompareIcon
        sx={{ fontSize: 40, color: BRAND_COLORS.cyan, opacity: 0.6, display: { xs: "none", sm: "block" } }}
      />
    </Box>
  </Box>
);

export default HomeHero;
